import { z } from "zod";
import zodToJsonSchema from "zod-to-json-schema";

/**
* Example:
  {
    "default": "HIDDEN",
    "result": "VISIBLE",
    "allOf": [
      {
        "rules": [
          {
            "dataType": "questionKey",
            "property": "grade-selection",
            "operator": "IN",  // NOTIN, EQUAL, NOTEQUAL
            "value": ["K", "PK"],
          }
        ],
      }
    ]
  }
*/

const IN = z.literal("IN");
const NOTIN = z.literal("NOTIN");
const EQUAL = z.literal("EQUAL");
const NOTEQUAL = z.literal("NOTEQUAL");

const QuestionRuleSchema = z.object({
  dataType: z.literal("questionKey"),
  property: z.string(),
  operator: z.union([IN, NOTIN, EQUAL, NOTEQUAL]),
  value: z.union([z.string(), z.array(z.string())]),
});
export type QuestionRule = z.infer<typeof QuestionRuleSchema>;

const SchoolRuleSchema = z.object({
  dataType: z.literal("school"),
  operator: z.union([IN, NOTIN, EQUAL, NOTEQUAL]),
  value: z.union([z.string(), z.array(z.string())]),
});
export type SchoolRule = z.infer<typeof SchoolRuleSchema>;

const RuleSchema = z.discriminatedUnion("dataType", [
  QuestionRuleSchema,
  SchoolRuleSchema,
]);
export type Rule = z.infer<typeof RuleSchema>;

const HIDDEN = z.literal("HIDDEN");
const VISIBLE = z.literal("VISIBLE");

const NoRule = z.object({
  default: z.union([HIDDEN, VISIBLE]),
  result: z.undefined(),
  anyOf: z.undefined(),
  allOf: z.undefined(),
  oneOf: z.undefined(),
});

const RulesSchema = z.object({
  rules: z.array(RuleSchema),
});

const WithRule = z.object({
  default: z.union([HIDDEN, VISIBLE]),
  result: z.union([HIDDEN, VISIBLE]),
  allOf: z.array(RulesSchema).optional(),
  oneOf: z.array(RulesSchema).optional(),
  anyOf: z.array(RulesSchema).optional(),
});

export type Rules = z.infer<typeof RulesSchema>;
export const VisibilitySchema = z.union([NoRule, WithRule]);
export const VisibilityJsonSchema = zodToJsonSchema(VisibilitySchema);
export type Visibility = z.infer<typeof VisibilitySchema>;
